 //https://lbs.amap.com/demo/javascript-api-v2/example/mass-markers/labelmarker
 let icon = {
    // 图标类型，现阶段只支持 image 类型
    type: 'image',
    // 图片 url
    image:
      'https://static.xchengtech.cn/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250217170224.png',
    // 图片尺寸
    size: [64, 30],
    // 图片相对 position 的锚点，默认为 bottom-center
    anchor: 'center',
  };
 
   let textStyle={
    
        fontSize: 12,
        fontWeight: 'normal',
        fillColor: '#22886f',
        strokeColor: '#fff',
        strokeWidth: 2,
        fold: true,
        padding: '2, 5',
      
  }


  /**
   * 
   * @param {name,content,postion} params 
   */
  export function setMarker(params){
    let marker =  {
        name: params.name,
        position: [params.longitude,params.latitude],
        zooms: [10, 20],
        opacity: 1,
        zIndex: 16,
        icon,
        extData :{
            index: params.index,
            id: params.id
          },
        text: {
          content: params.content,
          direction: 'right',
          offset: [-20, -5],
          style: textStyle,
        },
      }
      return marker
  }


// WEBPACK FOOTER //
// ./src/utils/map.js